MOVE.AmenitiesNearYouADS = (function(MOVE) {

  var init,
    updateInsuranceCategory,
    updateSponsoredByLabel,
    updateSponsorImage,
    attachSponsorOmnitureTags,
    trackThirdParty,
    mapvertisingData,
    mapAmentiyCategoryToAds,
    setAdsData,
    getAdsData,
    renderAmenities,
    insuranceTile = $('li#insurances'),
    insuranceContainer = $('label#insurances');

  init = function(mapvertisingDataFromAds) {
    if (mapvertisingDataFromAds) {
      var category = mapvertisingDataFromAds.category;
      // In Future there will be 5 more categories. So we can use Switches.
      if (category === 'Insurance') {
        updateInsuranceCategory(mapvertisingDataFromAds);
      }
    }
  };

  /*
  Updates the Insurance category with Insurance Ads. It
  */
  updateInsuranceCategory = function(mapvertisingDataFromAds) {
    if (MOVE.AmenitiesNearYou.allAmenitiesData()) {
      renderAmenities(mapvertisingDataFromAds);
    }
    else {
      $('#amenitiesMap').on('amenitiesDataReady', function() {
        renderAmenities(mapvertisingDataFromAds);
      });
    }
  };

  renderAmenities = function(mapvertisingDataFromAds) {
    var amenities = MOVE.AmenitiesNearYou.allAmenitiesData();

    mapAmentiyCategoryToAds(amenities, mapvertisingDataFromAds, 'insurances');
    insuranceContainer.addClass('label-sponsor');
    updateSponsorImage(insuranceContainer, mapvertisingDataFromAds.logo_image_26_26);
    updateSponsoredByLabel(insuranceContainer, mapvertisingDataFromAds.name);
    MOVE.AmenitiesNearYou.plotAmenities(amenities);
    attachSponsorOmnitureTags();
    trackThirdParty(mapvertisingDataFromAds.customer_imp_tracking);
  };

  updateSponsoredByLabel = function(element, sponsorName) {
    return element.find('span.ldp-amenity-sponsor').text('Sponsored by ' + sponsorName);
  };

  updateSponsorImage = function(element, sponsorImage) {
    var insuranceImagePlaceholder = element.find('.ldp-amenity-sponsor-logo');
    insuranceImagePlaceholder.html('<img src="' + sponsorImage + '" />');
  };

  /*
   Remaps the Amenities response with the Ads JSON response
  */
  mapAmentiyCategoryToAds = function(amenities, mapvertisingDataFromAds) {
    if (amenities) {
      _.map(amenities.insurances, function(amenity) {
        if (amenity.name.indexOf(mapvertisingDataFromAds.name) > -1) {
          amenity.havingAdCampaign = amenity.name.indexOf(mapvertisingDataFromAds.name) > -1;
          amenity.logo = mapvertisingDataFromAds.tooltip_image;
          amenity.yelp_url = amenity.business_url;
        }
        return amenity;
      });
    }
  };

  /*
    Once the Ads are successful. We need to attach new omniture tags
    and send some custom tracking
  */
  attachSponsorOmnitureTags = function() {
    var insuranceRadioButton = insuranceTile.find('input:radio');
    insuranceRadioButton.attr("data-omtag", "ldp:sponsor:amenities:insurances:card");
  };

  trackThirdParty = function(trackingUrl) {
    if (trackingUrl) {
      var token = Math.random();
      var finalTrackingUrl = trackingUrl.replace('CACHEBUSTER', token).replace('=?', '=?token=' + token);
      var img = $('<img />', {src: finalTrackingUrl});
      img.addClass('hide');
      img.appendTo($('#qv-sections-wrapper'));
    }
  };

  setAdsData = function(data){
    mapvertisingData = data;
  };

  getAdsData = function(){
    return mapvertisingData;
  };

  MOVE.AmenitiesNearYouADS = {
    init: init,
    setAdsData: setAdsData,
    getAdsData: getAdsData
  };
  return MOVE.AmenitiesNearYouADS;

})(MOVE || {});


/*
 setMapAds is a function set by the Ads server which powers the Ads targeting
  for Amenities Map.
*/
window.setMapAds = function(mapvertisingData) {
  MOVE.AmenitiesNearYouADS.setAdsData(mapvertisingData);
  $('#amenitiesMap').trigger('MapVertisingDataReady');
};



// WEBPACK FOOTER //
// ./media/mapvertising.js